'use client';

import React from 'react';
import { MessageCircleMore } from 'lucide-react';
import { DynamicIcon } from 'lucide-react/dynamic';
import { usePathname } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { MotionLink } from '@/components/ui/Motion';
import {
  TypographyH3,
  TypographySmall,
  TypographyH2,
} from '@/components/ui/typography';
import { URLS } from '@/lib/consts';
import { cls, getServicePath } from '@/lib/utils';
import Flex from '@/components/ui/layout/flex';
import SectionBase from '@/components/ui/sections/section-base';
import GETTING_STARTED_SECTION_CONTENT, {
  CTA_BUTTON_TEXT,
  GETTING_STARTED_SECTION_ID,
  SUB_HEADER,
} from './consts';

export default function GettingStarted() {
  const pathname = usePathname();
  const servicePath = getServicePath(pathname);

  if (!servicePath) {
    return null;
  }

  const { title, description, steps } =
    GETTING_STARTED_SECTION_CONTENT[servicePath];

  return (
    <SectionBase id={GETTING_STARTED_SECTION_ID}>
      <Card
        id={GETTING_STARTED_SECTION_ID}
        className={cls`
          flex
          flex-col
          gap-10
          bg-secondary-foreground
          p-5
          md:p-10
        `}
      >
        <CardHeader
          className={cls`justify-center items-center gap-2 p-0 text-center`}
        >
          <TypographyH3 className={cls`font-bold text-primary`}>
            {SUB_HEADER}
          </TypographyH3>
          <TypographyH2 className={cls`border-b-0`}>{title}</TypographyH2>
          <TypographySmall className={cls`mt-0!`}>
            {description}
          </TypographySmall>
        </CardHeader>

        <CardContent className={cls`flex flex-col gap-5 p-0`}>
          <Flex
            direction="column"
            justify="center"
            items="start"
            gap="gap-5"
            md="md:flex-row"
          >
            {steps.map((step, index) => (
              <Flex
                key={step.title}
                direction="column"
                gap="gap-2"
                className="flex-1"
              >
                <div className={cls`mb-2`}>
                  <DynamicIcon name={step.iconName} size={48} />
                </div>

                <TypographyH3 className={cls`text-center`}>
                  Step {index + 1}:
                  <br />
                  {step.title}
                </TypographyH3>

                <TypographySmall className={cls`m-0! text-center`}>
                  {step.description}
                </TypographySmall>
              </Flex>
            ))}
          </Flex>

          <Flex direction="column">
            <Button asChild>
              <MotionLink href={URLS.REQUEST_CONSULTATION}>
                <MessageCircleMore className={cls`mr-1`} />
                {CTA_BUTTON_TEXT}
              </MotionLink>
            </Button>
          </Flex>
        </CardContent>
      </Card>
    </SectionBase>
  );
}
